import { config } from "assets/config/config";

export const blockRobots = () => {
    const metaTags = [
        { name: "robots", content: "noindex, nofollow, noarchive, nosnippet, notranslate, noimageindex" },
        { name: "googlebot", content: "noindex, nofollow, noarchive, nosnippet, notranslate, noimageindex" },
        { name: "bingbot", content: "noindex, nofollow, noarchive, nosnippet, notranslate, noimageindex" },
        { name: "yandex", content: "noindex, nofollow, noarchive, nosnippet, notranslate, noimageindex" },
        { name: "baiduspider", content: "noindex, nofollow, noarchive, nosnippet, notranslate, noimageindex" }
    ];

    metaTags.forEach(({ name, content }) => {
        let metaTag = document.querySelector(`meta[name='${name}']`);

        if (!metaTag) {
            metaTag = document.createElement("meta");
            metaTag.setAttribute("name", name);
            document.head.appendChild(metaTag);
        }

        metaTag.setAttribute("content", content);
    });
}

export const removeRobots = () => {
    document.querySelectorAll("meta[name='robots'], meta[name='googlebot'], meta[name='bingbot'], meta[name='yandex'], meta[name='baiduspider']")
        .forEach(meta => meta.remove());
}

export const removePaginationLinksTags = () => {
    document.querySelectorAll("link[rel='prev']").forEach(link => link.remove());
    document.querySelectorAll("link[rel='next']").forEach(link => link.remove());
};

export const removePaginationPrevLinkTag = () => {
    document.querySelectorAll("link[rel='prev']").forEach(link => link.remove());
};

export const removePaginationNextLinkTag = () => {
    document.querySelectorAll("link[rel='next']").forEach(link => link.remove());
};

export const removeAllDynamicHeadTags = () => {
    const selectors = [
        "meta[name='description']",
        "meta[name='robots']",
        "meta[name='googlebot']",
        "meta[property^='og:']",
        "meta[name^='twitter:']",
        "meta[property^='product:']",
        "meta[name^='product:']",
        "meta[property^='book:']",
        "meta[property^='music:']",
        "meta[property^='video:']",
        "meta[property='original_publication_date']"
    ];

    const linkSelectors = [
        "link[rel='canonical']",
        "link[rel='prev']",
        "link[rel='next']"
    ];

    document.querySelectorAll(selectors.join(",")).forEach(el => el.remove());
    document.querySelectorAll(linkSelectors.join(",")).forEach(el => el.remove());
    document.querySelectorAll("script[type='application/ld+json']").forEach(script => script.remove());
};

export const cleanDescription = (rawDescription) => {
  if (!rawDescription) return "";
  return rawDescription
    .replace(/<xml[\s\S]*?<\/xml>/gi, "")
    .replace(/<style[\s\S]*?<\/style>/gi, "")
    .replace(/<\/?[^>]+(>|$)/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&oacute;/g, "ó")
    .replace(/&bdquo;/g, "„")
    .replace(/&rdquo;/g, "”")
    .replace(/&ndash;/g, "–")
    .replace(/&mdash;/g, "—")
    .replace(/&hellip;/g, "…")
    .replace(/&alpha;/g, "ą")
    .replace(/\s+/g, ' ')
    .trim();
};

export const upsertLinkTag = (rel, href) => {
    let linkTag = document.querySelector(`link[rel='${rel}']`);

    if (!linkTag) {
        linkTag = document.createElement("link");
        linkTag.setAttribute("rel", rel);
        document.head.appendChild(linkTag);
    }

    linkTag.setAttribute("href", href);
};

export const updatePaginationLinkTags = (metaData, siteUrl, params = '') => {
    const baseUrl = config.APP_MAIN_URLL;

    if (Number(metaData.currentPage) < Number(metaData.lastPage)) {
        upsertLinkTag("next", `${baseUrl}/${siteUrl}?page=${metaData.nextPage}${params ? `&${params}` : ''}`);
    } else {
        removePaginationNextLinkTag();
    }

    if (Number(metaData.currentPage) > 1) {
        upsertLinkTag("prev", `${baseUrl}/${siteUrl}?page=${Number(metaData.currentPage) - 1}${params ? `&${params}` : ''}`);
    } else {
        removePaginationPrevLinkTag();
    }
};

export const updateHeadTags = (tags) => {
    tags.forEach(({ name, property, content, rel, href, title }) => {
        if (title) {
            document.title = title;
        } else if (name || property) {
            const selector = name ? `meta[name='${name}']` : `meta[property='${property}']`;
            let metaTag = document.querySelector(selector);

            if (!metaTag) {
                metaTag = document.createElement("meta");
                if (name) metaTag.setAttribute("name", name);
                if (property) metaTag.setAttribute("property", property);
                document.head.appendChild(metaTag);
            }

            if (content) metaTag.setAttribute("content", content);
        } else if (rel && href) {
            let linkTag = document.querySelector(`link[rel='${rel}']`);

            if (!linkTag) {
                linkTag = document.createElement("link");
                linkTag.setAttribute("rel", rel);
                document.head.appendChild(linkTag);
            }

            linkTag.setAttribute("href", href);
        }
    });
};

export const updateStructuredData = (jsonLdData) => {
    let scriptTag = document.querySelectorAll("script[type='application/ld+json']")[0];

    if (!scriptTag) {
        scriptTag = document.createElement("script");
        scriptTag.setAttribute("type", "application/ld+json");
        document.head.appendChild(scriptTag);
    }

    scriptTag.textContent = JSON.stringify(jsonLdData, null, 2);
}